module.exports = __webpack_public_path__ + "static/media/GlobalMap.d4ac988e.svg";